import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";

const modalRoot = document.getElementById("modal-root");

const MODAL_SEARCH = ({
  id = "",
  modalClass = "",
  modalSize = "md",
  backgroundColor = "#fff",
  isOpen,
  onClose,
  children,
}) => {
  const [fadeType, setFadeType] = useState(null);

  // Handle Mount, Unmount, and Escape Key
  useEffect(() => {
    const onEscKeyDown = (e) => {
      if (e.key !== "Escape") return;
      setFadeType("out");
    };

    window.addEventListener("keydown", onEscKeyDown, false);

    // Trigger initial mount animation
    const timeout = setTimeout(() => setFadeType("in"), 0);

    return () => {
      window.removeEventListener("keydown", onEscKeyDown, false);
      clearTimeout(timeout);
    };
  }, []);

  // Listen for changes to the isOpen prop to trigger closing animation
  useEffect(() => {
    if (!isOpen) {
      setFadeType("out");
    }
  }, [isOpen]);

  const transitionEnd = (e) => {
    if (e.propertyName !== "transform" || fadeType === "in") return;

    if (fadeType === "out") {
      onClose();
    }
  };

  const handleBackgroundClick = (e) => {
    e.preventDefault();
    setFadeType("out");
  };

  if (!modalRoot) return null;

  const isFadedIn = fadeType === "in";

  // --- Inline Styles ---
  const wrapperStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    width: "430px",
    maxWidth: "calc(100vw - 40px)",
    height: "700px",
    maxHeight: "calc(100vh - 70px)",
    boxSizing: "border-box",
    marginRight: "auto",
    marginLeft: "auto",
    zIndex: 3,
  };

  const dialogStyle = {
    borderRadius: "7px",
    zIndex: 1050,
    width: "100%",
    backgroundColor: backgroundColor,
    boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.071)",

    // 1. Sets the scale anchor to the horizontal center, and vertically ABOVE the modal
    transformOrigin: "center -100px",

    // 2. translateY(-150px) pushes it up when closed. translateY(0) drops it down into place when open.
    transform: isFadedIn
      ? "scale(1) translateY(0)"
      : "scale(0.5) translateY(-150px)",

    // 3. Smooth, decelerating animation curve
    transition: "transform 0.45s cubic-bezier(0.16, 1, 0.3, 1)",
  };

  const backgroundStyle = {
    background: "#19214f78",
    position: "fixed",
    zIndex: 1040,
    display: "block",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    outline: 0,
  };

  return ReactDom.createPortal(
    <div
      id={id}
      className={`wrapper size-${modalSize} fade-${fadeType} ${modalClass}`}
      role="dialog"
      style={wrapperStyle}
    >
      <div
        className="box-dialog"
        style={dialogStyle}
        onTransitionEnd={transitionEnd}
      >
        <div className="box-content">{children}</div>
      </div>

      <div
        className="background"
        style={backgroundStyle}
        onMouseDown={handleBackgroundClick}
      />
    </div>,
    modalRoot,
  );
};

export default MODAL_SEARCH;
